import * as z from "zod";
import { requiredString } from "components/form/utils";

export const surveySchema = z.object({
  title: requiredString(),
  questions: z.array(z.string()).optional().default([]),
});
